export default "__VITE_ASSET__89318910__"